var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container container__top"},[_c('h1',{class:['container__header', { 'container__header--margin': !_vm.useActionSlot }]},[_vm._t("header")],2),_vm._t("top-actions"),_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }